import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, LockKeyhole, Mail, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import api, { getError } from "@/api";

export default function LoginPage({ bootstrap, onAuthenticated }) {
  const [mode, setMode] = useState(bootstrap ? "bootstrap" : "login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const update = (event) => setForm({ ...form, [event.target.name]: event.target.value });
  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const endpoint = mode === "bootstrap" ? "/auth/bootstrap" : "/auth/login";
      const payload = mode === "bootstrap" ? form : { email: form.email, password: form.password };
      const response = await api.post(endpoint, payload);
      onAuthenticated(response.data);
      navigate("/dashboard");
    } catch (error) {
      toast.error(getError(error));
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="auth-screen" data-testid="authentication-screen">
      <section className="auth-brand-panel" data-testid="authentication-brand-panel">
        <div className="auth-grid" />
        <div className="auth-brand-content">
          <div className="brand-mark large" data-testid="auth-brand-mark"><img src="/api/branding/logo" alt="Logo Ecom Guinée" onError={(event) => { event.currentTarget.style.display = "none"; }} /><span>E.G</span></div>
          <p className="eyebrow light" data-testid="auth-eyebrow">GESTION DE STOCK INFORMATISÉE D’ECOM GUINÉE</p>
          <h1 data-testid="auth-title">Connaître l’état de vos stocks en temps réel !</h1>
          <p data-testid="auth-description">Pilotez les stocks, les mouvements et les documents de votre réseau avec précision.</p>
        </div>
        <div className="auth-proof" data-testid="auth-security-message"><ShieldCheck size={18} /> Accès sécurisé selon vos responsabilités</div>
      </section>
      <section className="auth-form-panel">
        <form onSubmit={submit} className="auth-form" data-testid="login-form">
          <p className="eyebrow" data-testid="auth-form-eyebrow">{mode === "bootstrap" ? "CONFIGURATION INITIALE" : "ESPACE OPÉRATEUR"}</p>
          <h2 data-testid="auth-form-title">{mode === "bootstrap" ? "Créez l’administrateur principal" : "Bon retour."}</h2>
          <p className="auth-subtitle" data-testid="auth-form-description">{mode === "bootstrap" ? "Ce premier compte pourra inviter les utilisateurs et paramétrer l’organisation." : "Connectez-vous pour accéder à votre périmètre de stock."}</p>
          {mode === "bootstrap" && <label data-testid="name-field-label">Nom complet<input required name="name" value={form.name} onChange={update} data-testid="name-input" placeholder="Votre nom" /></label>}
          <label data-testid="email-field-label">E-mail ou nom d’utilisateur<input required type="text" name="email" value={form.email} onChange={update} data-testid="email-input" placeholder="nom@entreprise.com ou identifiant" /></label>
          <label data-testid="password-field-label">Mot de passe<input required minLength="8" type="password" name="password" value={form.password} onChange={update} data-testid="password-input" placeholder="8 caractères minimum" /></label>
          <Button type="submit" disabled={loading} className="auth-submit" data-testid="login-form-submit-button">{loading ? "Connexion…" : mode === "bootstrap" ? "Créer et ouvrir l’espace" : "Se connecter"}<ArrowRight size={17} /></Button>
          <div className="auth-divider" data-testid="auth-divider"><span>ou</span></div>
          <Button type="button" variant="outline" onClick={googleLogin} className="google-button" data-testid="google-login-button"><span className="google-g">G</span> Continuer avec Google</Button>
          <div className="auth-form-footer" data-testid="auth-form-footer"><LockKeyhole size={15} /> Accès réservé aux utilisateurs autorisés</div>
        </form>
      </section>
    </div>
  );
}